import { useQuery } from '@tanstack/react-query';
import { getSubdomain, isValidSubdomain } from '@zealy/utils';
import { tradingCompetitionKeys } from '../tradingCompetition.keys';
import { isUserRegistered } from '../tradingCompetition.service';
/**
 * Check if the current user is registered to a trading competition
 * @param tradingCompetitionId The ID of the trading competition
 * @param subdomain The subdomain of the community to query, @default subdomain will be inferred from the URL
 * @param enabled Whether the query should be enabled
 * @example const { data: isRegistered, isLoading } = useIsUserRegistered('competition-id');
 */
export const useIsUserRegistered = (tradingCompetitionId, subdomain, enabled = true) => {
    const domain = subdomain || getSubdomain();
    return useQuery({
        queryKey: tradingCompetitionKeys.isUserRegistered(domain, tradingCompetitionId),
        queryFn: async () => isUserRegistered(domain, tradingCompetitionId),
        enabled: isValidSubdomain(domain) && !!tradingCompetitionId && enabled,
        retry: 1,
    });
};
